import { Validator } from '@vista-digital/validator';
import { defaultFilmTrailerAssets, filmTrailerAssetsValidator } from './assets';
import { defaultFilmTrailerConfig, filmTrailerConfigValidator } from './config';
import { defaultFilmTrailerDisplayText, filmTrailerDisplayTextValidator } from './display-text';
import { filmTrailerEventsValidator } from './events';
export const defaultFilmTrailerProps = {
    config: defaultFilmTrailerConfig,
    displayText: defaultFilmTrailerDisplayText,
    assets: defaultFilmTrailerAssets,
    events: {}
};
export const filmTrailerPropsValidator = Validator.object({
    config: filmTrailerConfigValidator,
    displayText: filmTrailerDisplayTextValidator,
    assets: filmTrailerAssetsValidator,
    events: filmTrailerEventsValidator
});
